import React from "react";
import { Link } from "react-router-dom";
import { Button } from "semantic-ui-react";
import AthleteSummary from "../athletes/AthleteSummary";
import { placeHolderImage } from "./EventCard";

const VisitorList = (props) => {
  return (
    <>
      {props.flag ? (
        <>
          <ul>
            {props.listTwo &&
              props.listTwo.length > 0 &&
              props.listTwo.map((visitor) => {
                return (
                  <li key={visitor.id}>
                    <div className="eventVisitorFull">
                      <div className="one">
                        <img
                          src={
                            visitor.image && visitor.image !== "None"
                              ? visitor.image
                              : placeHolderImage
                          }
                          alt="images"
                        />
                      </div>
                      <div
                        className={`two ${
                          props.superAdmin ? "" : "full-width"
                        }`}
                      >
                        <Link to={`/about`} target="_blank">
                          <p>{visitor.name}</p>
                        </Link>
                      </div>
                      {props.superAdmin && (
                        <div className="three">
                          <Button
                            icon="close"
                            circular
                            basic
                            size="mini"
                            color="red"
                            onClick={() => props.remove(visitor.id)}
                          />
                        </div>
                      )}
                    </div>
                  </li>
                );
              })}
          </ul>
        </>
      ) : (
        <>
          <ul>
            {props.listOne &&
              !props.defaultView &&
              props.listOne.length > 0 &&
              props.listOne.map((visitor) => {
                return (
                  <li key={visitor.id}>
                    {/* <div className="eventVisitorFull"> */}

                    <Link to={`/athletes/${visitor.customUrl}`} target="_blank">
                      <AthleteSummary
                        athlete={visitor.extraData}
                        key={visitor.id}
                        athleteKey={visitor.id}
                      />
                    </Link>
                    {props.superAdmin && (
                      <div className="three">
                        <Button
                          icon="close"
                          circular
                          basic
                          size="mini"
                          color="red"
                          onClick={() => props.remove(visitor.id)}
                        />
                      </div>
                    )}

                    {/* </div> */}
                  </li>
                );
              })}
            {props.listOne &&
              props.defaultView &&
              props.listOne.length > 0 &&
              props.listOne.map((visitor) => {
                return (
                  <li key={visitor.id}>
                    <div className="eventVisitorFull">
                      <div className="one">
                        <img
                          src={
                            visitor.image && visitor.image !== "None"
                              ? visitor.image
                              : placeHolderImage
                          }
                          alt="images"
                        />
                      </div>
                      <div
                        className={`two ${
                          props.superAdmin ? "" : "full-width"
                        }`}
                      >
                        <Link
                          to={`/athletes/${visitor.customUrl}`}
                          target="_blank"
                        >
                          <p>{visitor.name}</p>
                        </Link>
                      </div>
                      {props.superAdmin && (
                        <div className="three">
                          <Button
                            icon="close"
                            circular
                            basic
                            size="mini"
                            color="red"
                            onClick={() => props.remove(visitor.id)}
                          />
                        </div>
                      )}
                    </div>
                  </li>
                );
              })}
          </ul>
        </>
      )}
    </>
  );
};

export default VisitorList;
